export const checkTimedContentIsActive = (
  startDate?: string,
  endDate?: string,
) => {
  const now = new Date();
  const start = startDate && new Date(startDate);
  const end = endDate && new Date(endDate);
  return start && end && now >= start && now <= end;
};
